<div class="idea-page">
  <p class="page-title">Ideeën</p>

  <div class="idea-card">
    <form [formGroup]="form" (ngSubmit)="submit()" class="idea-form">
      <mat-form-field appearance="outline" class="idea-field">
        <mat-label>Nieuw idee</mat-label>
        <input matInput formControlName="ideaname" placeholder="Bijv. avocado's">
        <mat-icon matSuffix>lightbulb</mat-icon>
      </mat-form-field>
      <button mat-flat-button type="submit" class="add-btn" [disabled]="!form.value.ideaname">
        Voeg toe
      </button>
    </form>
  </div>

  @if (ideas.length === 0) {
    <div class="empty-state">
      <mat-icon>emoji_objects</mat-icon>
      <p>Nog geen ideeën. Voeg er een toe!</p>
    </div>
  }

  <div class="ideas-list">
    @for (idea of ideas; track idea.id) {
      <div class="idea-row">
        <span class="idea-name">{{ idea.name }}</span>
        <button mat-icon-button class="delete-btn" (click)="removeItem(idea.id)" title="Verwijder">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
    }
  </div>
</div>
